import { render, staticRenderFns } from "./WorkflowLanding.vue?vue&type=template&id=bbb4554c"
import script from "./WorkflowLanding.vue?vue&type=script&setup=true&lang=ts"
export * from "./WorkflowLanding.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports